import script from "./ChooseMaterialModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChooseMaterialModal.vue?vue&type=script&setup=true&lang=js"

import "./ChooseMaterialModal.vue?vue&type=style&index=0&id=08e9e4ca&lang=less&scoped=true"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08e9e4ca"]])

export default __exports__